
import { API_ENDPOINT } from "../constants";
import { HTTP } from "./http";

export const FormService = {

    getForms: (account_id) => {
        return HTTP.get<any, any>(`${API_ENDPOINT.CORE}accounts/get-forms-close/${account_id}`);
    },
   
    delete: (form_id) => {
        return HTTP.delete<any, any>(`${API_ENDPOINT.CORE}accounts/delete-form/${form_id}`);
    },
    
    save: (form) => {
        return HTTP.post<any, any>(`${API_ENDPOINT.CORE}accounts/addForm`, form);
    },
    
    update: (form) => {
        return HTTP.post<any, any>(`${API_ENDPOINT.CORE}accounts/editForm`, form);
    },
    
    getForm: (id) => {
        return HTTP.post<any, any>(`${API_ENDPOINT.CORE}accounts/getFormById`, { form_id: id });
    },
    
    changeStatus: (id, status ) => {
        return HTTP.post<any, any>(`${API_ENDPOINT.CORE}accounts/changeStatusForm`, { form_id: id, status });
    },
}